import {
  ERC1155_INTERFACE,
  ERC165_INTERFACE,
  ERC721_INTERFACE,
} from '@/domain/create/constants';
import { ERC721 } from '@nftx/abi';
import { Address } from 'nftx.js';
import { getContract } from 'viem';
import { PublicClient } from 'wagmi';

export const supportsInterface = async ({
  client,
  assetAddress,
}: {
  client: PublicClient<any>;
  assetAddress: Address;
}): Promise<
  [supports721: boolean, supports1155: boolean, supports165: boolean]
> => {
  const contract = getContract({
    address: assetAddress,
    abi: ERC721,
    publicClient: client,
  });

  const supports721 = await contract.read.supportsInterface([
    ERC721_INTERFACE as `0x${string}`,
  ]);

  const supports1155 = await contract.read.supportsInterface([
    ERC1155_INTERFACE as `0x${string}`,
  ]);

  const supports165 = await contract.read.supportsInterface([
    ERC165_INTERFACE as `0x${string}`,
  ]);

  return [supports721, supports1155, supports165];
};
